import { GaussianBlurBackgroundProcessor, isSupported } from '@twilio/video-processors';
import { LocalAudioTrack, LocalVideoTrack } from 'twilio-video';
import { useCallback, useRef, useState } from 'react';

export const useVideoFilter = (localTracks: (LocalAudioTrack | LocalVideoTrack)[]) => {
  const localVideoTrack = localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack;
  const [ isEnabled, setEnabled ] = useState(false);
  const isProcessing = useRef(false);

  const toggleVideoFilter = useCallback(async (reset?: boolean) => {
    if (reset) {
      setEnabled(false);
      return;
    }

    if (isProcessing.current) return;
    isProcessing.current = true;

    try {
      if (localVideoTrack && isSupported) {
        if (localVideoTrack.processor) {
          localVideoTrack.removeProcessor(localVideoTrack.processor);
          setEnabled(false);
        } else {
          const gaussianBlurProcessor = new GaussianBlurBackgroundProcessor({
            assetsPath: '/assets/',
            maskBlurRadius: 10,
            blurFilterRadius: 20,
          });

          await gaussianBlurProcessor.loadModel();

          if (!localVideoTrack.processor) {
            localVideoTrack.addProcessor(gaussianBlurProcessor);
            setEnabled(true);
          }
        }
      }
    } finally {
      isProcessing.current = false;
    }
  }, [ localVideoTrack ]);

  return {
    toggleVideoFilter,
    isSupported,
    isEnabled
  };
};
